import styled from 'styled-components'

export const FormErrorMessage = styled.div`
  font-size: 12px;
  color: #990000;
  margin-top: 3px;
`
